export default {
  // Console tabs (ConsoleTabs on md+, BottomTabs on phones)
  tabs: {
    label: 'Main navigation',
    home: 'Home',
    browse: 'Browse',
    search: 'Search',
    wishlist: 'Wishlist',
    account: 'Account',
  },
  nav: {
    catalog: 'Catalog',
    allGames: 'All games',
    preorders: 'Pre-orders',
    help: 'Help',
  },
  search: {
    placeholder: 'Search games, DLC, gift cards…',
    recent: 'Recent searches',
    // Plural: 1 result | N results
    seeAll: 'See all {count} result | See all {count} results',
  },
  palette: {
    label: 'Quick search',
    recentlyViewed: 'Recently viewed',
    goTo: 'Go to',
    forget: 'Remove "{term}" from recent searches',
  },
  aria: {
    home: 'KeyzoStore — home',
    search: 'Search games',
    favorites: 'My favorites',
    cart: 'Cart, {count} in basket',
    menu: 'Menu',
    userMenu: '{name} menu',
  },
  menu: {
    dashboard: 'Account Dashboard',
    orders: 'Orders',
    wishlist: 'Wishlist',
    billing: 'Billing & Wallet',
    settings: 'Settings',
    admin: 'Admin',
    language: 'Language',
    platforms: 'Platforms',
    shopByPrice: 'Shop by price',
    discover: 'Discover',
    browseAll: 'Browse all games',
    comingSoon: 'Coming soon',
  },
  price: {
    under5: 'Under 5 €',
    from5: '5–10 €',
    from10: '10–20 €',
    from20: '20 € and up',
  },
  language: {
    aria: 'Change language',
  },
  accountFallback: 'Your account',
  account: 'Account',
  login: 'Login',
  signup: 'Signup',
};
